import React from "react";
import { Button } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AppleIcon from "@material-ui/icons/Apple";
import AndroidIcon from "@material-ui/icons/Android";
import MobileAppStoreMenu from "../../components/MobileAppStoreMenu/MobileAppStoreMenu";
import { ANDROID_APP_OPTIONS, IOS_APP_OPTIONS } from "../../constants/mobileApps";
import "./MobileApps.css";

const publicImg = (name) => `${process.env.PUBLIC_URL}/images/${name}`;

const FEATURES = [
  "School admins manage multiple branch schools from one dashboard",
  "Teachers log activities with Quick Activity Entry",
  "Parents access assignments, feed, and progress on mobile",
];

const APP_PREVIEWS = [
  {
    id: "admin",
    label: "School Admin",
    caption: "Multiple branches at a time",
    badge: "Multiple branches",
    badgeClass: "home-mobile-apps__badge--admin",
    type: "laptop",
    image: publicImg("school-admin-branches.png"),
  },
  {
    id: "teacher",
    label: "Teacher App",
    caption: "Quick Activity Entry",
    badge: "Classroom ready",
    badgeClass: "home-mobile-apps__badge--teacher",
    type: "phone",
    image: publicImg("teacher-app-mobile.png"),
  },
  {
    id: "parent",
    label: "Parent App",
    caption: "Assignments & Events",
    badge: "Family access",
    badgeClass: "home-mobile-apps__badge--parent",
    type: "phone",
    image: publicImg("parent-app-menu.png"),
  },
];

const MobileApps = () => (
  <section className="home-mobile-apps">
    <div className="home-mobile-apps__inner">
      <div className="home-mobile-apps__copy">
        <h2 className="home-mobile-apps__title">
          Take MonteStory <span className="home-mobile-apps__accent">Anywhere</span>
        </h2>
        <p className="home-mobile-apps__lead">
          Run parent and child branch schools from one place. Admins switch between
          locations instantly while teachers and parents stay connected on mobile.
        </p>

        <ul className="home-mobile-apps__list">
          {FEATURES.map((text) => (
            <li key={text}>
              <CheckCircleIcon className="home-mobile-apps__check" />
              <span>{text}</span>
            </li>
          ))}
        </ul>

        <div className="home-mobile-apps__stores">
          <MobileAppStoreMenu options={IOS_APP_OPTIONS}>
            <Button variant="contained" className="home-mobile-apps__store-btn" startIcon={<AppleIcon />}>
              App Store
            </Button>
          </MobileAppStoreMenu>
          <MobileAppStoreMenu options={ANDROID_APP_OPTIONS}>
            <Button variant="contained" className="home-mobile-apps__store-btn" startIcon={<AndroidIcon />}>
              Google Play
            </Button>
          </MobileAppStoreMenu>
        </div>
      </div>

      <div className="home-mobile-apps__previews">
        {APP_PREVIEWS.map((app) => (
          <figure
            key={app.id}
            className={`home-mobile-apps__device home-mobile-apps__device--${app.id} home-mobile-apps__device--${app.type}`}
          >
            <span className={`home-mobile-apps__badge ${app.badgeClass}`}>{app.badge}</span>

            {app.type === "laptop" ? (
              <div className="home-mobile-apps__laptop">
                <div className="home-mobile-apps__laptop-chrome">
                  <span /><span /><span />
                </div>
                <div className="home-mobile-apps__laptop-screen">
                  <img src={app.image} alt={`${app.label} preview`} />
                </div>
              </div>
            ) : (
              <div className="home-mobile-apps__phone">
                <div className="home-mobile-apps__phone-screen">
                  <img src={app.image} alt={`${app.label} preview`} />
                </div>
              </div>
            )}

            <figcaption className="home-mobile-apps__caption">
              <strong>{app.label}</strong>
              <span>{app.caption}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default MobileApps;
